
import { Component, Vue } from 'vue-property-decorator';
import { SessionManager } from "@/components/utils/utils";
import Tooltip from "@/components/survey/Tooltip.vue"
import { getBCEIDUrl } from "@/components/utils/utils";

@Component({
    components:{
        Tooltip
    }
})
export default class LandingPage extends Vue {
    
    isLoggedIn= false;
    pageReady = false;
    openInfoModal = false;
      
    async mounted() {
        this.pageReady = false;
        this.openInfoModal = false;
        await SessionManager.getUserInfo(this.$store);
        if(this.$store.state.Common.userId !== ""){
            this.isLoggedIn = true;
            this.confirmLogin();
            // this.determineUserType();
            
        }else{
            this.isLoggedIn = false;
            this.pageReady = true;
        } 
    }
  
    public navigate(userType) {
        if (userType === "new") {
            //Register a BCeID
            window.location.replace(getBCEIDUrl());
        } else if (userType === "returning") {
            //Login BCeID
            this.$router.push({ name: "surveys" });
        }  
    }  

    public confirmLogin(){
        this.openInfoModal = false;
        this.$router.push({ name: "applicant-status" });
    }
    public goToLoginPage(){
        this.openInfoModal = false;
        this.$router.push({ name: "qualified" });
    }

    public determineUserType () {
      
        this.$http.get('/app-list/')
        .then((response) => {
            if(response.data.length>0) {
                this.confirmLogin();
            }else{
                this.navigate("new");
            }        
        
        },(err) => console.log(err));
    }
  
};
